import { useStore as baseUseStore } from 'vuex';
import { storeKey } from '@/store';
import type { ProjectMemberRootState } from '@/modules/projectMember/types';

export const useStore = () => baseUseStore<ProjectMemberRootState>(storeKey);
